import axios from 'axios';
import { getWorkSpaceApiBearerToken } from './msalAPIITokenAcquire';
import { msalInstance } from '.';

// Axios Instance
let instance = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  },
});

instance.interceptors.request.use(async (config) => {
  try {
    const newConfig = { ...config };
    if (newConfig.method === 'get' && newConfig.url.includes('/GetClientList')) {
      const { accessToken } = await getWorkSpaceApiBearerToken(
        `api://${process.env.REACT_APP_CLIENT_CODE}/user_impersonation`
      );
      newConfig.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (newConfig.method === 'get' && newConfig.url.includes('/GetMatchedSecurityGroupData')) {
      const { accessToken } = await getWorkSpaceApiBearerToken(
        `api://${process.env.REACT_APP_CLIENT_CODE}/user_impersonation`
      );

      const account = msalInstance.getAllAccounts()?.[0];
      const email = account?.username;
      newConfig.headers = {
        ...newConfig.headers, // Keep existing headers if needed
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
        Appserviceuid: '00000020-4535-0000-0000-000000000000',
        CorrelationUId: '00000020-4535-0000-0000-000000000000',
        Useremailid: email.split('@')[0], // Set user email ID (local part)
        Authorization: `Bearer ${accessToken}`,
      };
    }

    return newConfig;
  } catch (error) {
    return Promise.reject(error);
  }
});

//  Axios methods
const AxiosInstance = {
  get: (url) => {
    return instance.get(url);
  },
};

export default AxiosInstance;
